import React, { useState, useEffect } from 'react';
import { certificateAPI } from '../services/api';

function CertificatePreviewModal({ isOpen, onClose, certificate }) {
  const [zoom, setZoom] = useState(100);
  const [signedUrl, setSignedUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch signed URL when modal opens
  useEffect(() => {
    if (isOpen && certificate && certificate.file_url) {
      setLoading(true);
      // Fetch signed URL from backend
      certificateAPI.getDownloadUrl(certificate.id)
        .then(data => {
          setSignedUrl(data.url);
          setLoading(false);
        })
        .catch(err => {
          console.error('Failed to get signed URL:', err);
          setLoading(false);
        });
    } else {
      setSignedUrl(null);
      setLoading(false);
    }
  }, [isOpen, certificate]);

  if (!isOpen || !certificate) return null;

  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 25, 200));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 25, 50));
  const handleZoomReset = () => setZoom(100);

  const handleDownload = () => {
    if (signedUrl) {
      window.open(signedUrl, '_blank');
    }
  };

  const isPDF = certificate.file_name?.toLowerCase().endsWith('.pdf');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{certificate.certificate_name || certificate.name}</h2>
          <button className="btn-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="preview-controls">
            <div className="zoom-controls">
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleZoomOut}
                disabled={zoom <= 50}
              >
                &#8722;
              </button>
              <span className="zoom-label">{zoom}%</span>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleZoomIn}
                disabled={zoom >= 200}
              >
                &#43;
              </button>
              <button className="btn btn-outline btn-sm" onClick={handleZoomReset}>
                Reset
              </button>
            </div>
            <button className="btn btn-primary btn-sm" onClick={handleDownload}>
              ⬇️ Download
            </button>
          </div>

          <div className="preview-container">
            {loading ? (
              <div className="preview-placeholder">
                <div className="preview-placeholder-icon">⏳</div>
                <p>Loading certificate...</p>
              </div>
            ) : signedUrl ? (
              isPDF ? (
                <iframe
                  src={signedUrl}
                  title={certificate.file_name}
                  className="preview-iframe"
                  style={{ transform: `scale(${zoom / 100})` }}
                />
              ) : (
                <img
                  src={signedUrl}
                  alt={certificate.file_name}
                  className="preview-image"
                  style={{ transform: `scale(${zoom / 100})` }}
                />
              )
            ) : (
              <div className="preview-placeholder">
                <div className="preview-placeholder-icon">📄</div>
                <p>No file available</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default CertificatePreviewModal;
